import { render, staticRenderFns } from "./mainbusinessPage3.vue?vue&type=template&id=f46b0760&scoped=true&"
import script from "./mainbusinessPage3.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage3.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage3.vue?vue&type=style&index=0&id=f46b0760&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46b0760",
  null
  
)

export default component.exports